<template>
<div class="chapter">
<div class="inner_page">
<p class="fm3">“With what wonderful wisdom has George Eliot told us that people are not any better because they have long eyelashes!”</p>
<p class="fm4">Mary Elizabeth Braddon, <em>Aurora Floyd</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?070ca544